import { Service } from '@angular/core';
import { fetchEventSource } from '@microsoft/fetch-event-source';
import { Duration } from 'luxon';
import { defer, Observable, retry, timer } from 'rxjs';

@Service()
export class SseHelper {
  public connect$(url: () => string, token: () => string): Observable<string> {
    return defer(() => this.stream$(url(), token())).pipe(
      retry({
        delay: (_, retryCount) =>
          timer(
            Math.min(
              Duration.fromObject({
                seconds: 2 ** (retryCount - 1),
              }).toMillis(),
              Duration.fromObject({ minute: 1 }).toMillis(),
            ),
          ),
        resetOnSuccess: true,
      }),
    );
  }

  private stream$(url: string, token: string): Observable<string> {
    return new Observable((subscriber) => {
      const controller = new AbortController();

      fetchEventSource(url, {
        headers: { Authorization: `Bearer ${token}` },
        signal: controller.signal,
        openWhenHidden: true,
        onmessage: ({ data }) => data && subscriber.next(data),
        onclose: () => subscriber.error(new Error('SSE connection closed')),
        onerror: (error: unknown) => {
          throw error;
        },
      }).catch((error: unknown) => subscriber.error(error));

      return () => controller.abort();
    });
  }
}
